import React from 'react';
import { Input } from './input';
import { cn } from '../../lib/utils';

export default function MobileInput({
  value,
  onChange,
  error,
  className,
  id,
  required,
  disabled,
  placeholder = '10-digit mobile number',
  ...props
}) {
  const handleChange = (e) => {
    onChange?.(digitsOnly(e.target.value));
  };

  return (
    <div className="space-y-1">
      <Input
        id={id}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={10}
        value={value ?? ''}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        className={cn(error && 'border-destructive focus-visible:ring-destructive', className)}
        aria-invalid={Boolean(error)}
        {...props}
      />
      {error ? <p className="text-xs text-destructive">{error}</p> : null}
    </div>
  );
}

function digitsOnly(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, 10);
}
